import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kqfv9z6tvp: FaireBrandEntity = {
  token: "b_kqfv9z6tvp",
  type: "brand",
  name: "Cora's Den",
  avatarUrl:
    "https://cdn.faire.com/fastly/7400cd546a2e28bbc66238e6d5d97e574560e125133a5b9ad416208128401e0d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/23c4da97a4d9b85bf9c33293050a85ed7a1e4ec13ae18e21a62c62b226b6d604.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7400cd546a2e28bbc66238e6d5d97e574560e125133a5b9ad416208128401e0d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/23c4da97a4d9b85bf9c33293050a85ed7a1e4ec13ae18e21a62c62b226b6d604.png",
  location: "MORRILTON, AR, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 38,
  isInsider: true,
  description:
    "Cora's Den Jewelry is handmade in the United States and can be customized to fit your shops needs. We are a family owned small business and would love for our brand to be featured in your store. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:08.560Z",
    importedBy: "entity-db-cli",
  },
};
